import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import DropDownInput from '../Input/dropDownInput/dropDownInput';
import {
  INITIAL_REFERRAL_FILTERS,
  STATUS_FILTER_OPTIONS,
} from 'pages/valetServices/siteLeadReferral/constants';

const LEGACY_OPTIONS = [
  { id: 'false', name: 'No' },
  { id: 'true', name: 'Yes' },
];

const SiteLeadReferralFilter = ({ applyFilter, listFilterData }) => {
  const appliedValues = listFilterData?.appliedFilterValues;
  const [filterFieldsData, setFilterFieldsData] = useState(INITIAL_REFERRAL_FILTERS);

  useEffect(() => {
    if (appliedValues) {
      setFilterFieldsData({
        status: appliedValues.status ?? '',
        include_legacy: appliedValues.include_legacy === true,
      });
    } else {
      setFilterFieldsData(INITIAL_REFERRAL_FILTERS);
    }
  }, [appliedValues]);

  const legacyValue = filterFieldsData.include_legacy ? 'Yes' : 'No';

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <DropDownInput
        label={localization.status}
        data={STATUS_FILTER_OPTIONS}
        value={
          filterFieldsData.status
            ? STATUS_FILTER_OPTIONS.find((o) => o.id === filterFieldsData.status)?.name || ''
            : 'All'
        }
        getIdValue={(val) =>
          setFilterFieldsData((prev) => ({ ...prev, status: val?.id ?? '' }))
        }
      />
      <DropDownInput
        label="Include legacy"
        data={LEGACY_OPTIONS}
        value={legacyValue}
        getIdValue={(val) =>
          setFilterFieldsData((prev) => ({
            ...prev,
            include_legacy: val?.id === 'true',
          }))
        }
      />
      <br />
      <br />
      <div className="btn-wrapper">
        <button type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(INITIAL_REFERRAL_FILTERS);
            applyFilter(INITIAL_REFERRAL_FILTERS);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

SiteLeadReferralFilter.propTypes = {
  applyFilter: PropTypes.func.isRequired,
  listFilterData: PropTypes.shape({
    appliedFilterValues: PropTypes.object,
  }),
};

SiteLeadReferralFilter.defaultProps = {
  listFilterData: null,
};

export default SiteLeadReferralFilter;
